import { gql } from "@apollo/client";

export default gql`
  mutation UpdateGovernmentProfile($governmentId: ObjectId!, $government: UpdateGovernmentProfileInput!) {
    updateGovernmentProfile(governmentId: $governmentId, government: $government) {
      _id
      site
      budget
      logo
    }
  }
`;
